import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect';
import collapse from '@alpinejs/collapse'
// import Swiper from 'swiper';
// import 'swiper/css';
import imagesLoaded from 'imagesloaded';

Alpine.plugin(intersect);
Alpine.plugin(collapse);
window.Alpine = Alpine;
//window.Swiper = Swiper;

Alpine.start();

const body = document.body;
const select = e => document.querySelector(e);
const selectAll = e => document.querySelectorAll(e);

customCursor();
function customCursor() {
    var cursor = select('.js-cursor');
    document.addEventListener('mousemove', t => {
        var curX = t.clientX;
        var curY = t.clientY;
        cursor.classList.add('!block');
        cursor.style.transform =
            'translate(calc(' + curX + 'px - 50%),calc(' + curY + 'px - 50%))';
    });

    document.addEventListener('mouseleave', () => {
        cursor.classList.remove('!block');
    });
}

if(body.classList.contains('template--about')) {
    window.addEventListener('scroll', aboutImageSwapper);
}
function aboutImageSwapper() {
    const swapTriggers = document.querySelectorAll('.section-trigger');
    const swapImage = document.querySelector('.sticky-image-container');
    const sideNavLinks = document.querySelectorAll('.sidenav-link a');
    const tolerance = 25;

    let swapImageOffset = swapImage.getBoundingClientRect().top;

    swapTriggers.forEach((trigger, index) => {
        const triggerOffset = trigger.getBoundingClientRect().top;

        if(triggerOffset > (swapImageOffset - tolerance) && triggerOffset < (swapImageOffset + tolerance)) {
            if (!trigger.classList.contains('active')) {
                trigger.classList.add('active');

                sideNavLinks[0].classList.remove('active');
                sideNavLinks.forEach((link) => {
                    if(link.getAttribute('href').includes(trigger.getAttribute('data-section-slug'))) {
                        link.classList.add('active');
                    } else {
                        link.classList.remove('active');
                    }
                });

                const currentSrc = swapImage.querySelector('img').getAttribute('src');
                const newSrc = trigger.getAttribute('data-image-src');

                if (currentSrc !== newSrc) {
                    swapImage.classList.add('switching');
                    window.setTimeout(() => {
                        swapImage.querySelector('img').setAttribute('src', newSrc);

                        window.setTimeout(() => {
                            swapImage.classList.remove('switching');
                        }, 100);
                    }, 100);
                }
            }
        } else {
            trigger.classList.remove('active');
        }
    });
}

const element = document.querySelector("#projectContainer");

element.addEventListener('wheel', (event) => {
  event.preventDefault();

  element.scrollBy({
    left: event.deltaY < 0 ? -50 : 50,

  });
});
